import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    ref: "host",
    class: "wechat-open-launch-app-host",
    onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
  }, null, 512);
}